module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av651-498f2af84dd489145f4d93403ecb8d13.jpg";